import React, {lazy} from 'react';
import {createBrowserRouter, createRoutesFromElements, Route} from "react-router-dom";
import {APPOINTMENT_TYPE_SPACE, APPOINTMENT_TYPE_STAFF} from "@arboxappv4/shared/src/constants/constants";
import KioskContainer from "./src/kioskStandAlone/layout/KioskContainer";

const Home = lazy(() => import(/* webpackChunkName: "Home" */'./src/screens/home/Content'));
const HomeContainer = lazy(() => import(/* webpackChunkName: "HomeContainer" */'./src/screens/home/HomeContainer'));
const Register = lazy(() => import(/* webpackChunkName: "RegisterFlow" */'./src/screens/register/RegisterFlow'));
const MembershipPurchase = lazy(() => import(/* webpackChunkName: "MembershipPurchaseFlow" */'./src/screens/membershipPurchase/MembershipPurchaseFlow'));
const NotFound = lazy(() => import(/* webpackChunkName: "NotFound" */'./src/screens/404/NotFound'));
const GroupSessionsFlow = lazy(() => import(/* webpackChunkName: "GroupSessionsFlow" */'./src/screens/groupSessions/GroupSessionsFlow'));
const AppointmentFlow = lazy(() => import(/* webpackChunkName: "AppointmentFlow" */'./src/screens/appointment/AppointmentFlow'));
const CourseFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/screens/course/CourseFlow'));
const TrackFlow = lazy(() => import(/* webpackChunkName: "TrackFlow" */'./src/screens/track/TrackFlow'));
const ShopFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/screens/shop/ShopFlow'));
const WaiverFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/screens/waiver/WaiverFlow'));
const ProfileWrap = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/screens/profile/ProfileWrap'));
const CloseDebtFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/kioskStandAlone/screens/CloseDebtFlow'));
const ArrivalConfirmationFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/kioskStandAlone/screens/ArrivalConfirmationFlow'));
const CloseAllDebtsFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/kioskStandAlone/screens/CloseAllDebtsFlow'));
const AppointmentWaitlistFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/screens/appointmentWaitlist/AppointmentWaitlistFlow'));
const AppointmentWaitlistOfferFlow = lazy(() => import(/* webpackChunkName: "CourseFlow" */'./src/kioskStandAlone/screens/AppointmentWaitlistOfferFlow'));

export const siteRouter = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<HomeContainer />}>
            <Route path="/" element={<Home />} exact />
            <Route path="staff-appointment" element={<AppointmentFlow type={APPOINTMENT_TYPE_STAFF}/>}>
                <Route path=":id" />
            </Route>
            <Route path="space-appointment" element={<AppointmentFlow type={APPOINTMENT_TYPE_SPACE}/>}>
                <Route path=":id" />
            </Route>
            <Route path="group" element={<GroupSessionsFlow/>}>
                <Route path="trial/:id" />
                <Route path=":id" />
            </Route>
            <Route path="shop" element={<ShopFlow/>}>
                <Route path=":id" />
            </Route>
            <Route path="membership" element={<MembershipPurchase/>}>
                <Route path=":id" />
            </Route>
            <Route path="course" element={<CourseFlow/>}>
                <Route path=":id" />
            </Route>
            <Route path="track" element={<TrackFlow/>}>
                <Route path=":id" />
            </Route>
            <Route path="register" element={<Register />} />
            <Route path='*' element={<NotFound />}/>
            <Route path="form" element={<WaiverFlow/>}/>
            <Route path="profile" element={<ProfileWrap/>}>
                <Route path=":tab" />
            </Route>
            <Route path="appointment-waitlist" element={<AppointmentWaitlistFlow/>}/>
        </Route>
    )
);

export const kioskRouter = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<KioskContainer />}>
            <Route path="/kiosk">
                <Route path="close-debt" element={<CloseDebtFlow/>}/>
                <Route path="arrival-confirmation" element={<ArrivalConfirmationFlow />} />
                <Route path="close-all-debts" element={<CloseAllDebtsFlow/>}/>
                <Route path="waitlist-offer" element={<AppointmentWaitlistOfferFlow/>}/>
            </Route>
            <Route path='*' element={<NotFound />}/>
        </Route>
    )
)
